<template>
	<div id="effectiveMerchartList">
		<div style="margin-bottom: 20px;">
		    <el-button size="small" icon="el-icon-back" @click="$router.back()">返 回</el-button>
		</div>
		<!-- 表格部分 -->
		<el-card class="box-card" style="margin-top: 20px;" shadow="hover">
			<el-table :data="transferList.list" size="mini" border style="width: 100%" v-loading="loading">
				<el-table-column header-align="center" align="center" prop="merchant_name" label="商户名称"
					min-width="150"></el-table-column>
				<el-table-column header-align="center" align="center" prop="merchant_number" label="商户编号"
					min-width="150"></el-table-column>
                <el-table-column header-align="center" align="center" prop="terminal_sn" label="SN"
                	min-width="180"></el-table-column>
                <el-table-column header-align="center" align="center" prop="channel_from_text" label="进件渠道" min-width="150">
                </el-table-column>
				<el-table-column header-align="center" align="center" prop="real_name" label="直属代理名称"
					min-width="150"></el-table-column>
				
                <el-table-column header-align="center" align="center" prop="register_time" label="入网成功时间" min-width="180">
                </el-table-column>
                <el-table-column header-align="center" align="center" prop="bind_time" label="绑机时间" min-width="180">
                </el-table-column>
                <el-table-column header-align="center" align="center" prop="active_time" label="激活时间" min-width="180">
                </el-table-column>
                <!-- <el-table-column header-align="center" align="center" prop="lively_time" label="活跃率达标时间" min-width="180">
                </el-table-column> -->
				<!-- <el-table-column header-align="center" align="center" prop="month_money_all" label="本月交易量(万元)" min-width="150">
				</el-table-column> -->
			</el-table>
			<!-- 分页部分 -->
			<paginations :currentPage="page.currentPage" :pageSize="page.pageSize" :total="page.total"
				@watchCurrent="getCurrent" @watchPageSize="getPageSize" style="text-align: center"></paginations>
		</el-card>
        
	</div>
</template>

<script>
	import paginations from '../../../components/pagination/paginations';
	export default {
		name: "effectiveMerchartList",
		data() {
			return {
                formInline:{
                    date:this.$route.query.date,
                    user_id:this.$route.query.user_id
                },
				transferList: {
					list: [],
				},
				page: {
					currentPage: 1, //当前页码
					pageSize: 10, //条数
					total: 0 //总数
				},
				loading: true
			}
		},
		mounted() {
			this.getData()
		},
		components: {
			paginations,
		},
		methods: {
            
			//分页
			getCurrent(page) {
				// 获取当前页修改的值
				this.page.currentPage = page;
				this.loading = true;
				this.getData();
			},
			getPageSize(limit) {
				this.page.currentPage = 1;
				// 获取条数发生改变的值
				this.page.pageSize = limit;
				this.loading = true;
				this.getData()
			},
			getData() {
                this.formInline.page = this.page.currentPage
                this.formInline.limit = this.page.pageSize
				this.$api.post("user_dividends/merchantEffectiveList", this.formInline, res => {
					let data = res.data;
					this.page.total = data.total; //总数
					this.transferList.list = res.data.data;
					//渲染结束后取消加载
					this.loading = false;
				})
			}
		}
	};
</script>





<style lang="scss" scope>
	.el-input__inner {
		font-size: 12px;
	}

	.el-form-item {
		margin-bottom: 5px;
	}

	.el-date-editor .el-range-input,
	.el-date-editor .el-range-separator {
		font-size: 12px;
	}

	.el-popover__title {
		font-size: 12px;
		font-weight: 700;
	}

	.MAM_terminalList {
		.el-input__inner {
			font-size: 12px;
		}

		.el-form-item {
			margin-bottom: 5px;
		}

		.tableTitle {
			display: inline-block;
			margin-right: 20px;
		}
	}

	.terminal_operate {
		display: flex;
	}

	.el-button {
		font-size: 12px !important;
	}
</style>